<div
  class="ticket-container"
  [class.light]="isLight"
  [class.dark]="!isLight"
  [ngClass]="machinesCount > 0 ? 'state-alert' : 'state-warning'"
  >
  <div class="row w-100 recap-container">
    @if (machinesCount > 0) {
      <div class="col-12 col-lg-6">
        <div class="main-info gap-3">
          <div class="icon">
            <app-icam-icon [iconName]="'alert'" [isDefault]="true" iconHeight="40px" />
          </div>
          <div>
            <h2 class="title fw-semibold my-0 py-0 title-danger">
              {{ 'TICKET.MACHINE_ALERTS' | translate }}:
              {{ machinesCount }}
            </h2>
          </div>
        </div>
      </div>
    }
    @if (contractsCount) {
      <div class="col-12 col-lg-6" [ngClass]="machinesCount > 0 ? 'border-left' : ''">
        <div class="main-info gap-3">
          <div class="icon">
            <app-icam-icon [iconName]="'warning'" [isDefault]="true" iconHeight="35px" />
          </div>
          <div>
            <h2 class="title fw-semibold my-0 py-0 title-warning">
              <span>{{ 'TICKET.CONTRACT_WARNINGS' | translate }}: </span>
              <span>{{ contractsCount }}</span>
            </h2>
          </div>
        </div>
      </div>
    }
  </div>
</div>
